import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const Loader = ({ size = 40, className }) => (
  <div 
    className={classNames(
      'mx-auto animate-[fadeIn_0.4s_ease-in,rotation_1s_linear_infinite]',
      size === 48 ? 'loader--lg' : 'loader',
      className
    )}
  >
    <div className="box-border block after:box-border after:block after:animate-[rotation_1s_linear_infinite] after:border-4 after:border-success after:rounded-full after:border-l-transparent after:content-[''] after:h-full after:w-full" />
  </div>
)

Loader.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
}

export default Loader
